module.exports = __webpack_public_path__ + "img/buyuk-ayi.30aa4024.png";